import { initMasterPage } from '@tikvas/marketingblogs';
import { savePreviousPage } from '@wix-platform/blog-cross-posts'

$w.onReady(function () {
    initMasterPage();
    savePreviousPage()
});